<script setup lang="ts">
import type { ProjectProgress } from "@/types";

defineProps<{ progress: ProjectProgress; compact?: boolean }>();
const stageLabel = (stage: string) =>
  ({
    intake: "需求沟通",
    solution_drafting: "方案整理",
    solution_review: "方案待确认",
    project_draft: "项目草稿",
    submitted: "待团队接单",
    team_accepted: "团队已接单",
    scheduled: "已排期",
    in_progress: "执行中",
    awaiting_acceptance: "待客户验收",
    revision: "修改中",
    completed: "已完成",
  })[stage] || stage;
</script>

<template>
  <div class="progress" :class="{ compact }">
    <div class="progress__labels">
      <b>{{ progress.percent }}%</b>
      <span>{{ progress.completedItems }} / {{ progress.totalItems }} 项完成</span>
    </div>
    <div
      class="progress__track"
      role="progressbar"
      :aria-valuenow="progress.percent"
      aria-valuemin="0"
      aria-valuemax="100"
    ><span :style="{ width: `${progress.percent}%` }"></span></div>
    <div v-if="!compact" class="progress__meta">
      <span>{{ stageLabel(progress.stage) }}</span>
      <span v-if="progress.blockedItems" class="blocked">{{ progress.blockedItems }} 项阻塞</span>
      <span v-else-if="progress.delayed" class="delayed">已延期</span>
      <span v-else>{{ progress.nextActor === "client" ? "等待客户处理" : "团队处理中" }}</span>
    </div>
  </div>
</template>

<style scoped>
.progress{display:grid;gap:7px;min-width:0}.progress__labels,.progress__meta{display:flex;align-items:center;justify-content:space-between;gap:10px}.progress__labels b{font-size:20px}.progress__labels span,.progress__meta{color:var(--muted);font-size:12px}.progress__track{height:8px;overflow:hidden;background:#e7ecec}.progress__track span{display:block;height:100%;background:var(--success);transition:width .2s ease}.blocked{color:var(--danger)}.delayed{color:#a65c00}.compact{gap:5px}.compact .progress__labels b{font-size:15px}.compact .progress__track{height:6px}
</style>
